module.exports = __webpack_public_path__ + "static/img/oca-environment-report.36c6104.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/oca-environment-report.jpg
// module id = 3J1s
// module chunks = 0